import type { Notification } from '@/types';
import { NotificationListItem } from './notification-list-item';
import { NoData } from '@/components';

interface NotificationListProps {
  notifications: Notification[];
  onNotificationClick?: (id: string) => void;
  currentUserId?: string;
}

export function NotificationList({ notifications, onNotificationClick, currentUserId }: NotificationListProps) {
  if (notifications.length === 0) {
    return (
      <div className="py-20 flex flex-col items-center justify-center">
        <NoData title="No notifications found" />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {notifications.map((notification) => (
        <NotificationListItem
          key={notification.id}
          notification={notification}
          onClick={onNotificationClick}
          currentUserId={currentUserId}
        />
      ))}
    </div>
  );
}
